import React, { useCallback, useMemo, useState } from "react";
import Flx from "../layout/Flx";
import FilePreviewSideCardModal from "../modals/FilePreviewSideCardModal";
import FileChip from "../chips/FileChip";
import FilePreviewSideModal from "../modals/FilePreviewSideModal";
import { isNil } from "lodash";

const DocumentIdsRenderer = ({ documents, documentIds, color, sx, chipSx }) => {
  const [file, setFile] = useState(null);
  // const filteredFiles = documents?.filter((doc) =>
  //   documentIds?.includes(doc?._id),
  // );

  const filteredFiles = useMemo(() => {
    if (isNil(documentIds)) return documents;
    return documents?.filter((doc) => documentIds?.includes(doc?._id));
  }, [documents, documentIds]);

  const onPreviewFile = useCallback((file) => {
    setFile(file);
  }, []);
  return (
    <>
      <Flx wrap g={1} sx={sx}>
        {filteredFiles?.map((file) => (
          <FileChip
            key={file._id}
            file={file}
            onPreview={onPreviewFile}
            color={color}
            sx={chipSx}
          />
        ))}
      </Flx>
      <FilePreviewSideModal file={file} onClose={() => setFile(null)} />
      {/* <FilePreviewSideCardModal file={file} onClose={() => setFile(null)} /> */}
    </>
  );
};

export default DocumentIdsRenderer;
